module.exports = __webpack_public_path__ + "img/statistics_blue.d619b17e.svg";